var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountTabIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.53285 0.333332C9.43861 0.333332 10.9952 1.84593 10.9952 3.6979V4.59657C10.9952 5.46197 10.6548 6.25435 10.0963 6.85249C12.3903 7.12702 14.1667 9.02758 14.1667 11.3314C14.1667 12.6208 13.0903 13.6667 11.7632 13.6667H3.23679C1.90945 13.6667 0.833328 12.6209 0.833328 11.3314C0.833328 9.00767 2.64015 7.09427 4.96298 6.84563C4.40874 6.24896 4.07054 5.45954 4.07054 4.59657V3.6979C4.07054 1.84605 5.62735 0.333332 7.53285 0.333332ZM9.52242 7.96114H5.47718C3.56189 7.96114 2.00938 9.46993 2.00938 11.3314C2.00938 11.9897 2.55897 12.5238 3.23679 12.5238H11.7632C12.4408 12.5238 12.9906 11.9896 12.9906 11.3314C12.9906 9.47002 11.4378 7.96114 9.52242 7.96114ZM7.53285 1.47619C6.27684 1.47619 5.24659 2.47726 5.24659 3.6979V4.59657C5.24659 5.81698 6.27699 6.81832 7.5266 6.81832L7.5818 6.81778C8.81739 6.79227 9.8191 5.79937 9.8191 4.59657V3.6979C9.8191 2.47711 8.7891 1.47619 7.53285 1.47619Z",
    fill: "#A5A0B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountTabIcon);
export default __webpack_public_path__ + "static/media/account-tab-icon.412d23b41562bd73a0ccd6926c44e150.svg";
export { ForwardRef as ReactComponent };